import { FactoryDigitalmallBackofficeV1Product } from '../../app/genericApiGenerated';

const buildProduct = (
  data: any,
  selectedProduct?: FactoryDigitalmallBackofficeV1Product
): FactoryDigitalmallBackofficeV1Product => {
  const product: FactoryDigitalmallBackofficeV1Product = {};

  // This one for handling concurrent updates
  if (
    selectedProduct !== undefined &&
    selectedProduct['meta'] !== undefined &&
    selectedProduct['meta']['update_time'] !== undefined
  ) {
    product.meta = {
      ...product.meta,
      update_time: selectedProduct['meta']['update_time']
    };
  }

  if (data['name'] !== undefined) {
    product.name = data['name'];
  }

  if (data['display_name'] !== undefined) {
    product.display_name = data['display_name'];
  }

  if (data['gtin'] !== undefined) {
    product.gtin = data['gtin'];
  }

  if (data['mpn'] !== undefined) {
    product.mpn = data['mpn'];
  }

  if (data['parent_code'] !== undefined) {
    product.parent_code = data['parent_code'];
  }

  if (data['category'] !== undefined) {
    product.category = data['category'];
  }

  if (data['sub_category'] !== undefined) {
    product.sub_category = data['sub_category'];
  }

  if (data['gender'] !== undefined) {
    product.gender = data['gender'];
  }

  if (data['review'] !== undefined) {
    product.review = data['review'];
  }

  if (data['retailer_link'] !== undefined) {
    product.retailer_link = data['retailer_link'];
  }

  if (data['image_links'] !== undefined) {
    product.image_links = data['image_links'];
  }

  if (data['regular_price'] !== undefined) {
    product.regular_price = data['regular_price'];
  }

  if (data['sale_price'] !== undefined) {
    product.sale_price = data['sale_price'];
  }

  if (data['description'] !== undefined) {
    product.description = data['description'];
  }

  if (data['color'] !== undefined) {
    product.color = data['color'];
  }

  if (data['size'] !== undefined) {
    product.size = data['size'];
  }

  if (data['material'] !== undefined) {
    product.material = data['material'];
  }

  if (data['weather'] !== undefined) {
    product.weather = data['weather'];
  }

  if (data['fit'] !== undefined) {
    product.fit = data['fit'];
  }

  if (data['occasion'] !== undefined) {
    product.occasion = data['occasion'];
  }

  if (data['style'] !== undefined) {
    product.style = data['style'];
  }

  if (data['temporality'] !== undefined) {
    product.temporality = data['temporality'];
  }

  if (data['season'] !== undefined) {
    product.season = data['season'];
  }

  if (data['age_group'] !== undefined) {
    product.age_group = data['age_group'];
  }

  if (data['price_range'] !== undefined) {
    product.price_range = data['price_range'];
  }

  if (data['review_count'] !== undefined) {
    product.review_count = data['review_count'];
  }

  if (data['vat'] !== undefined) {
    product.vat = data['vat'];
  }

  if (data['ecotax'] !== undefined) {
    product.ecotax = data['ecotax'];
  }

  if (data['meta'] !== undefined && data['meta']['create_time'] !== undefined) {
    product.meta = {
      ...product.meta,
      create_time: data['meta']['create_time']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['creation_user'] !== undefined
  ) {
    product.meta = {
      ...product.meta,
      creation_user: data['meta']['creation_user']
    };
  }

  if (data['meta'] !== undefined && data['meta']['update_time'] !== undefined) {
    product.meta = {
      ...product.meta,
      update_time: data['meta']['update_time']
    };
  }

  if (data['meta'] !== undefined && data['meta']['update_user'] !== undefined) {
    product.meta = {
      ...product.meta,
      update_user: data['meta']['update_user']
    };
  }

  if (data['meta'] !== undefined && data['meta']['delete_time'] !== undefined) {
    product.meta = {
      ...product.meta,
      delete_time: data['meta']['delete_time']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['deletion_user'] !== undefined
  ) {
    product.meta = {
      ...product.meta,
      deletion_user: data['meta']['deletion_user']
    };
  }

  if (data['meta'] !== undefined && data['meta']['sfmc_mid'] !== undefined) {
    product.meta = {
      ...product.meta,
      sfmc_mid: data['meta']['sfmc_mid']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['resource_name'] !== undefined
  ) {
    product.meta = {
      ...product.meta,
      resource_name: data['meta']['resource_name']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['operation_name'] !== undefined
  ) {
    product.meta = {
      ...product.meta,
      operation_name: data['meta']['operation_name']
    };
  }

  return product;
};
export default buildProduct;
